// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tarountula: PokeData = {
  "id": 917,
  "name": "tarountula",
  "height": 3,
  "weight": 40,
  "base_experience": 42,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "counter",
    "string-shot",
    "block",
    "feint",
    "assurance",
    "gastro-acid",
    "bug-bite",
    "circle-throw",
    "struggle-bug",
    "sticky-web",
    "throat-chop",
    "skitter-smack"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "string-shot",
    "bug-bite",
    "sticky-web",
    "lunge",
    "infest",
    "pounce",
    "signal-spam",
    "pin-rush",
    "heal-order",
    "bug-buzz",
    "leech-steal"
  ],
  "evolution_chain": {
    "id": 482,
    "item": null,
    "species": [
      {
        "name": "tarountula",
        "order": 918,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "spidops",
        "order": 919,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 917,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 15,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 38.75,
    "speed": 20,
    "ability_power": 41
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
